import { PartyInvolved } from '../../../../../api/PartiesInvolved';
import { ReportStatus, SCNReport } from '../../../../../api/scnReports';
import { SCNResponseReport } from '../../../../../api/scnResponseReports';
import { ReportTabListItem } from '../../../../../components/ui/tabs/PrimaryReportTabList';
import { ReportStatusPillVariant } from '../../../../../constants/reports'


export const createSCNTabItems = (
  parties: PartyInvolved[],
  notices: Record<string, SCNReport>,
  responses: Record<string, SCNResponseReport>,
  isSCNPairLoading: boolean,
): ReportTabListItem[] => {
  return parties.map((party) => {
    const notice = notices[party.party_id];
    const response = responses[party.party_id];

    let pillVariant: ReportStatusPillVariant;
    let pillText: string;

    if (isSCNPairLoading) {
      pillVariant = 'default';
      pillText = 'Loading...';
    } 
    else if (!notice) {
      pillVariant = 'generate';
      pillText = 'Generate';
    } 
    else {
      switch (notice.status) {
        case ReportStatus.SUBMITTED:
        case ReportStatus.IN_PROGRESS:
          pillVariant = 'generate';
          pillText = 'Generating...';
          break;
        
        case ReportStatus.AVAILABLE:
          if (response?.is_response_received === true) {
            pillVariant = 'available';
            pillText = 'Completed';
          } else {
            pillVariant = 'available';
            pillText = 'Awaiting Response';
          }
          break;
        
        case ReportStatus.FAILED:
          pillVariant = 'no-response';
          pillText = 'Failed';
          break;
        
        default:
          pillVariant = 'generate';
          pillText = 'Generate';
      }
    }

    return {
      id: party.party_id,
      tabText: party.name,
      pillVariant,
      pillText,
      showBadge: true,
    };
  });
};


export const downloadFormats = [
    { value: 'pdf', label: 'PDF (.pdf)' },
    { value: 'docx', label: 'Word (.docx)' }
];